module.exports = __webpack_public_path__ + "img/box7.50751a0e.png";